import {Route, Routes} from "react-router-dom";
import React from "react";
import {RouterProps} from "../../RouterProps";
import List from "./List";
import Post from "./Post";
import Detail from "./Detail";
import Edit from "./Edit";

export default function NotificationRouter(props: RouterProps) {
    return <>
        <Routes>
            <Route path={'/'} element={<List {...props} />} />
            <Route path={'/post'} element={<Post {...props} />} />
            <Route path={'/:userNotificationId'} element={<Detail {...props} />} />
            <Route path={'/:userNotificationId/edit'} element={<Edit {...props} />} />
        </Routes>
    </>
}